<template>
  <div class="box">
    <div style="margin-bottom: 20px">
      <span>产品名称：</span>
      <Input
        placeholder="请输入"
        style="width: 200px; margin-right: 20px"
        v-model="productName"
      />
      <span>书籍查询：</span>
      <Input
        placeholder="请输入书籍名称 / ID"
        v-model="bookName"
        style="width: 200px; margin-right: 20px"
      />
      <span>分成时间：</span>
      <DatePicker
        type="daterange"
        placement="bottom-end"
        placeholder="开始时间 - 结束时间"
        style="width: 300px"
        @on-change="changeTime"
        v-model="RechargeTime"
      ></DatePicker>
      <Button type="primary" style="margin: 0px 20px" @click="searchData">查询</Button>
      <Button @click="resetValue">重置</Button>
    </div>
    <Alert style="width: 100%; margin-bottom: 20px" show-icon
      ><span
        >当前条件下总记录：{{ Count }} 充值金额总计：{{ sumRechargeAmount }}  分成金额总计：{{ Currency }}</span
      ></Alert
    >
    <Table stripe :columns="columns1" :data="rechargeData"></Table>
    <div style="float: right; margin-top: 20px">
      <Page @on-change="changePages" :total="Count"  :page-size="pageSize"/>
    </div>
  </div>
</template>
<script>
import { GetRechargeReport } from "@/api/api"; //接口测试
export default {
  data() {
    return {
      sumRechargeAmount:0,
      productName: "", //产品名称
      bookName: "", //书籍名称书籍ID
      RechargeTime: [], //充值时间
      startTime: "",
      endTime: "",
      Count: 0,
      Currency: 0,
      pageCount: 1,
      pageNo: 1,
      pageSize: 20,
      rechargeData: [],
      columns1: [
        {
          title: "产品名称",
          key: "appName",
        },
        {
          title: "充值金额",
          key: "rechargeAmount",
          sortable: true,
        },
        {
          title: "书籍名称/ID",
          key: "bookName",
          width:400,
          render:(h,params) => {
            var text=params.row.bookName+'/'+params.row.thirdBookId
           return h('span', {}, text)
        }
        },
        {
          title: "作者",
          key: "bookAuthor",
        },
        {
          title: "分成金额",
          key: "shareAmount",
        },
        {
          title: "分成时间",
          key: "rechargeTime",
        },
      ],
    };
  },
  mounted() {
      this.startTime = this.getDay(-31);
    this.endTime = this.getDay(-1);
    this.RechargeTime=[this.startTime,this.endTime]
    this.getData();
  },
  methods: {
    changeTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
    },
    resetValue() {
      this.productName = "";
      this.bookName = "";
      this.RechargeTime = "";
      this.startTime = "";
      this.endTime = "";
      this.pageNo = 1;
      this.getData();
    },
    getData() {
      //获取数据
      var params = {
        appName: this.productName,
        bookInfo: this.bookName,
        endTime: this.endTime,
        startTime: this.startTime,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      GetRechargeReport(params).then((res) => {
        if (res.code == 200) {
          this.rechargeData = res.data;
          this.pageCount = res.pages;
          this.Count=res.counts;
          this.Currency=res.sumDevideAmount;
          this.sumRechargeAmount=res.sumRechargeAmount;
        }
        console.log(res);
      });
    },
    changePages(value) {
      this.pageNo = value;
      this.getData();
    },
    searchData() {
      //查询数据
      this.pageNo = 1;
      this.getData();
    },
     getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
  },
};
</script>
<style lang="less" scoped>
.box {
  padding: 50px;
  > h1 {
    margin-bottom: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/RechargeRecord/RechargeRecord.vue